import GeneralSettings from 'pages/SettingsPage/General/GeneralSettings';

export default GeneralSettings;
